module.exports = __webpack_public_path__ + "img/1574027797.cd9b35f9.jpg";